import React from 'react';
import styled from 'styled-components';
import { Palette, MediaQuery } from 'core/config';
import { getContactUsUrl } from 'core/utilities';

export const CalendarCTA: React.FunctionComponent = () =>
{
    return (
        <Container>
            <Card>
                <TextContent>
                    <Label>READY TO LAUNCH YOUR STARTUP?</Label>
                    <Title>Your app is just <Highlight>24 hours</Highlight> away</Title>
                    <Body>
                      Join forward-thinking companies building defensible, high-value products with Speer. <br />
                      Partner with our expert team to scope and build your app.
                    </Body>
                    <Checks>
                        <Check><Tick>✓</Tick> Launch-ready for early adopters</Check>
                        <Check><Tick>✓</Tick> Built to generate revenue</Check>
                        <Check><Tick>✓</Tick> Scalable tech foundation</Check>
                    </Checks>
                </TextContent>

                <CTAContent>
                    <CTAButton href={getContactUsUrl({ intent: 'build' })}>
                        Build My App Now →
                    </CTAButton>
                    <CTANote>Takes less than 2 minutes</CTANote>
                </CTAContent>
            </Card>
        </Container>
    );
};

const Container = styled.div`
    @media ${MediaQuery.mobileS} {
        padding: 0 16px 100px 16px;
    }

    @media ${MediaQuery.tablet} {
        padding: 0 100px 100px 5rem;
    }

    @media ${MediaQuery.laptopL} {
        padding: 0 170px 100px 7rem;
    }
`;

const Card = styled.div`
    background-color: black;
    border-radius: 16px;
    display: flex;
    flex-direction: column;
    gap: 40px;
    padding: 48px 40px;

    @media ${MediaQuery.laptopS} {
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        padding: 56px 64px;
    }
`;

const TextContent = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
`;

const Label = styled.p`
    color: ${Palette.PACIFIC_BLUE};
    font-family: 'Poppins-Medium';
    font-size: 11px;
    letter-spacing: 0.15em;
    text-transform: uppercase;

    @media ${MediaQuery.laptopS} {
        font-size: 12px;
    }
`;

const Title = styled.h2`
    color: ${Palette.WHITE};
    font-family: 'Poppins-Medium';
    font-size: calc(1.5em + 2vw);
    line-height: 1.2em;

    @media ${MediaQuery.laptopS} {
        font-size: 42px;
    }
`;

const Highlight = styled.span`
    color: ${Palette.PACIFIC_BLUE};
`;

const Body = styled.p`
    color: ${Palette.SILVER};
    font-family: 'Poppins-Light';
    font-size: 14px;
    line-height: 1.7em;

    @media ${MediaQuery.laptopS} {
        font-size: 16px;
    }
`;

const Checks = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
    margin-top: 8px;

    @media ${MediaQuery.tablet} {
        flex-direction: row;
        gap: 32px;
    }
`;

const Check = styled.span`
    color: ${Palette.SILVER};
    font-family: 'Poppins-Light';
    font-size: 13px;
    display: flex;
    align-items: center;
    gap: 6px;

    @media ${MediaQuery.laptopS} {
        font-size: 14px;
    }
`;

const Tick = styled.span`
    color: ${Palette.PACIFIC_BLUE};
`;

const CTAContent = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 12px;
    flex-shrink: 0;

    @media ${MediaQuery.laptopS} {
        align-items: center;
    }
`;

const CTAButton = styled.a`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    background-color: white;
    color: black;
    border-radius: 50px;
    padding: 18px 36px;
    font-family: 'Poppins-Regular';
    font-size: 15px;
    cursor: pointer;
    white-space: nowrap;
    text-decoration: none;
    transition: background-color 0.2s ease-in-out, border-color 0.2s ease-in-out;

    &:hover {
        background-color: #F0F0F0;
    }

    @media ${MediaQuery.laptopS} {
        width: auto;
        font-size: 17px;
        padding: 20px 48px;
    }
`;

const CTANote = styled.p`
    color: ${Palette.DOVE_GRAY};
    font-family: 'Poppins-Light';
    font-size: 12px;
    text-align: center;
    width: 100%;
`;
